import {skipToken} from '@reduxjs/toolkit/query';

import {isNilOrEmpty} from 'ramda-adjunct';

import {FilterValues, SmartSearch, useCreateDataQueryQuery} from '@dms/api/core';

import {convertToSearchParams, type OrderByRequestBody} from 'features/eag-grid';

export function useDataQuery(
  code: string,
  options?: {
    filters?: FilterValues;
    order?: OrderByRequestBody[];
    smartSearch?: SmartSearch;
    skip?: boolean;
  }
) {
  const {data, ...rest} = useCreateDataQueryQuery(
    options?.skip
      ? skipToken
      : {
          code,
          createDataQueryRequestBody: {
            filters: options?.filters ?? {},
            order: options?.order ?? [],
            smartSearch: options?.smartSearch ?? null,
          },
        }
  );

  let queryParams: ReturnType<typeof convertToSearchParams> | undefined = undefined;
  if (data?.dataQueryId && !isNilOrEmpty(options)) {
    queryParams = convertToSearchParams({
      dataGrids: {
        gridCode: code,
        queryId: data.dataQueryId,
        rowIndex: '1',
      },
    });
  }

  return {
    gridCode: code,
    dataQueryId: data?.dataQueryId,
    queryParams,
    ...rest,
  };
}
